<div class=" align-items-center row  h-100 to-left-1" *ngIf="params.data.displayStatus === 'ACTIVE' && !params.data.isDatonManagedDestination">
    <ul class="table-sm-logos">
        <ng-container *ngFor="let source of params.data.sources; let i = index">
            <li [matTooltip]="source.name" class="cur-pointer" *ngIf="(i < 4)" ><img src="../../assets/images/source-logos/pngFormat/{{source.logoUrl}}" alt="">
                <!-- <div class="tooltip-section fade-in">
                    <div  class="tooltip-body" >
                        {{source.name}}
                    </div>
                </div> -->
            </li>
        </ng-container>

        <!-- <li><img src="../../assets/images/source-logos/Google_Search_Console.png" alt=""></li>
        <li><img src="../../assets/images/source-logos/Google_Search_Console.png" alt=""></li>
        <li><img src="../../assets/images/source-logos/Google_Search_Console.png" alt=""></li> -->
        <li class="logos-count" *ngIf="params.data.sources.length > 3"><span>+ {{(params.data.sources.length -3)}}</span></li>
        <!-- <li class="logos-count m-l-8" (click)="redirectSources()"><span>+</span></li> -->
        <!-- <span (click)="status=!status" class="show" >+</span> -->
    </ul>

    <div class="d-flex align-items-center row  h-100"   >

        <div class="{{(params.data.sources.length > 0?'ml-3':'')}}">
        <div class="Integrations-dropdown">
            <span (click)="status=!status" [ngClass]="status ? 'show' : ''">+</span>
            <div class="Integrations-dropdown-list my-scrollbar {{dataLength > 4 && ( (params.rowIndex + 4  === dataLength) || (params.rowIndex + 3  === dataLength) || (params.rowIndex + 2  === dataLength) || (params.rowIndex + 1  === dataLength) )?'integrations-dropdown-list-l2':''}}" >
                <h6 class="mb-1">Choose Integration</h6>
                <p>Select the source that you want to map for this destination </p>
                <div class="Integrations-overflow">
                    <ul class="Integrations-ul">
                        <li *ngFor="let source of params.data.no_dest_sources; let i = index" class="click-f {{(i === focusIndex?'focus-class':'')}}" (click)="focusIndex = i">
                            <div class="Integrations-img">
                                <img src="../../assets/images/source-logos/pngFormat/{{source.logoUrl}}" alt="">
                            </div>
                            <div class="Integrations-details">
                                <span class="text-strong-2">{{source.name}}</span>
                                <!-- <p>Receiving from {{warehouse.count}} sources</p> -->
                            </div>
                        </li>

                    </ul>
                </div>
                <div class="Integrations-addnew mt-3">
                    <span (click)="redirectSources()"><i class="fas fa-plus"></i> Add new Source</span>
                </div>
                <div class="row justify-content-end mt-4">
                    <div class="col-auto"><button mat-button color="primary" (click)="status=!status; focusIndex = undefined;">Cancel</button></div>
                    <div class="col-auto pl-0"><button mat-flat-button color="primary" [disabled]="focusIndex === undefined" (click)="setWarehouse(params.data.no_dest_sources[focusIndex].sourceId, params.data.warehouseId, params.data.type)">Confirm</button></div>
                </div>

            </div>
            </div>
        </div>
    </div>



</div>
<div class=" align-items-center row  h-100 to-left-1" *ngIf="params.data.displayStatus !== 'ACTIVE'">
    -/-
</div>